import { fromJS } from "immutable"
import { getInitLang } from "Utils"
// import { gamelist } from "./fakeData/gamelist"
// import { playerRank } from "./fakeData/playerRank"
// import { corner_tag } from "./fakeData/cornerTag"
// import { lang } from "./fakeData/lang"
// import { user } from "./fakeData/user"
// import { type } from "./fakeData/type"
// import { payout } from "./fakeData/payout"
const INIT_DATA = "INIT_DATA"
const CHANGE_DATA = "CHANGE_DATA"
const init_gametype = {
  index: 0,
  value: {
    name: "allGames",
    type: "all",
    gaClass: "ga_nav_all",
  },
}
const query = new URLSearchParams(window.location.hash)
const lobby_hasms = JSON.parse(query.get("hasms"))
const initialState = fromJS({
  lang: getInitLang("en"),
  theme: "main",
  gameType: init_gametype,
  userInfo: {},
  searchValue: "",
  popModalData: {},
  gameUrl: "",
  getAuth: false,
  isAuth: true,
  isLoading: true,
  mainAreaRoute: "Lobby",
  // api data
  gameList: [],
  langList: [],
  announcement: {
    data: [],
    isLoading: true,
  },
  newsTickerList: [],
  typeList: [],
  cornerTagList: {},
  advertise: {
    data: [],
    isLoading: true,
  },
  payoutRank: [],
  playerRank: [],
  featuredGames: [],
  hasCQ9VIPClub: lobby_hasms,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_DATA:
      return state.set(action.path, action.result)
    case CHANGE_DATA:
      return state.set(action.path, action.value)
    default:
      return state
  }
}

export { initialState, reducer }
